(() => {
  const PROMO_COPIED_CLASS = 'is-promocode-copied';
  const PROMO_HIDE_MS = 2200;

  const clearPromocodeHideTimer = feedback => {
    const id = feedback.dataset.hideTimerId;
    if (id) window.clearTimeout(Number(id));
    delete feedback.dataset.hideTimerId;
  };

  const showPromocodeCopied = feedback => {
    clearPromocodeHideTimer(feedback);
    feedback.classList.add(PROMO_COPIED_CLASS);
    feedback.setAttribute('aria-hidden', 'false');
    feedback.dataset.hideTimerId = String(
      window.setTimeout(() => {
        feedback.classList.remove(PROMO_COPIED_CLASS);
        feedback.setAttribute('aria-hidden', 'true');
        delete feedback.dataset.hideTimerId;
      }, PROMO_HIDE_MS)
    );
  };

  document.querySelectorAll('[data-capsule-promocode-copy]').forEach(btn => {
    btn.addEventListener('click', () => {
      const code = btn.getAttribute('data-promocode') || '';
      if (!code || !navigator.clipboard?.writeText) return;

      const wrap = btn.closest('[data-capsule-promocode-wrap]');
      const feedback = wrap?.querySelector('[data-capsule-promocode-feedback]');

      navigator.clipboard
        .writeText(code)
        .then(() => {
          if (feedback) showPromocodeCopied(feedback);
        })
        .catch(() => {});
    });
  });

  const originalCta = document.querySelector('[data-capsule-hero-cta]');
  const stickyBar = document.querySelector('[data-capsule-hero-sticky]');

  if (!originalCta || !stickyBar) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.add('tw-translate-y-full');
      } else {
        stickyBar.classList.remove('tw-translate-y-full');
      }
    },
    { threshold: 0 }
  );

  observer.observe(originalCta);

  const mobileStickyBtn = stickyBar.querySelector(
    '[data-capsule-hero-sticky-btn-mobile]'
  );
  const footer = document.querySelector('.footer');

  if (!mobileStickyBtn || !footer) return;

  const updateStickyBtnColor = () => {
    const footerRect = footer.getBoundingClientRect();
    const btnRect = mobileStickyBtn.getBoundingClientRect();

    if (btnRect.bottom < footerRect.top) {
      mobileStickyBtn.classList.remove('white');
    } else {
      mobileStickyBtn.classList.add('white');
    }
  };

  updateStickyBtnColor();
  document.addEventListener('scroll', updateStickyBtnColor, { passive: true });
})();
